import {
  type Configuration,
  type CreateRestoreTemplateRequest,
  type UpdateRestoreTemplateRequest,
  type RestoreTemplateResourceType,
  RestoreTemplatesApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/restore-templates';

export const restoreTemplates = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const restoreTemplatesApi = new RestoreTemplatesApi(config);

  return {
    useList: (resourceType?: RestoreTemplateResourceType, enabled = true) =>
      httpClient.execute(
        restoreTemplatesApi.listRestoreTemplates.bind(restoreTemplatesApi),
        enabled ? baseUrl : null,
        '',
        currentProjectId,
        resourceType
      ),
    useGet: (restoreTemplateId: string | null) =>
      httpClient.execute(
        restoreTemplatesApi.getRestoreTemplate.bind(restoreTemplatesApi),
        restoreTemplateId ? baseUrl : null,
        restoreTemplateId ?? '',
        currentProjectId,
        restoreTemplateId ?? ''
      ),
    create: (body: CreateRestoreTemplateRequest) =>
      restoreTemplatesApi.createRestoreTemplate(currentProjectId, body),
    update: (restoreTemplateId: string, body: UpdateRestoreTemplateRequest) =>
      restoreTemplatesApi.updateRestoreTemplate(
        currentProjectId,
        restoreTemplateId,
        body
      ),
    delete: (restoreTemplateId: string) =>
      restoreTemplatesApi.deleteRestoreTemplate(
        currentProjectId,
        restoreTemplateId
      ),
    bulkAttach: (restoreTemplateId: string, resourceIds: string[]) =>
      restoreTemplatesApi.bulkAttachRestoreTemplate(
        currentProjectId,
        restoreTemplateId,
        { resourceIds }
      ),
    bulkDetach: (restoreTemplateId: string, resourceIds: string[]) =>
      restoreTemplatesApi.bulkDetachRestoreTemplate(
        currentProjectId,
        restoreTemplateId,
        { resourceIds }
      ),
    useRevalidate: (restoreTemplateId: string, resourceId?: string) =>
      httpClient.execute(
        restoreTemplatesApi.revalidateRestoreTemplate.bind(restoreTemplatesApi),
        restoreTemplateId ? baseUrl : null,
        'revalidate',
        currentProjectId,
        restoreTemplateId,
        resourceId ? { resourceId } : undefined
      ),
    useEvaluate: (
      restoreTemplateId: string,
      resourceId: string,
      snapshotId: string
    ) =>
      httpClient.execute(
        restoreTemplatesApi.evaluateRestoreTemplate.bind(restoreTemplatesApi),
        restoreTemplateId ? baseUrl : null,
        'evaluate',
        currentProjectId,
        restoreTemplateId,
        resourceId,
        snapshotId
      ),
  };
};
